import { render, staticRenderFns } from "./coupon-edit.vue?vue&type=template&id=28c51bcc&scoped=true&"
import script from "./coupon-edit.vue?vue&type=script&lang=js&"
export * from "./coupon-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c51bcc",
  null
  
)

export default component.exports